/**
 * Global Middleware: Initialize Permissions & Packages
 *
 * Ensures USMAN permissions and package configurations are loaded
 * before any page/component tries to use them.
 *
 * This middleware runs on every route and ensures stores are initialized.
 */

export default async function initPermissions({ store, $auth }) {
  // Skip if user is not authenticated
  if (!$auth.loggedIn) {
    return
  }

  // Initialize both stores in parallel for better performance
  await Promise.all([initUsman(store, $auth), initPackages(store)])
}

/**
 * Initialize USMAN store
 */
async function initUsman(store, $auth) {
  // Set user role if available
  if ($auth.user && $auth.user.role) {
    store.commit('usman/SET_USER_ROLE', $auth.user.role)
  }

  // Skip if already initialized or currently loading
  const isInitialized = store.state.usman.isInitialized
  const isLoading = store.state.usman.isLoading

  if (isInitialized || isLoading) {
    return
  }

  try {
    await store.dispatch('usman/fetchUsmanConfig')
  } catch (error) {
    // Fail gracefully - don't block navigation
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.warn('USMAN initialization failed:', error)
    }
  }
}

/**
 * Initialize Package store
 */
async function initPackages(store) {
  // Skip if already initialized or currently loading
  const isInitialized = store.state.package.isInitialized
  const isLoading = store.state.package.isLoading

  if (isInitialized || isLoading) {
    return
  }

  try {
    await store.dispatch('package/fetchPackageConfig')
  } catch (error) {
    // Fail gracefully - don't block navigation
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.warn('Package initialization failed:', error)
    }
  }
}
